import { render, staticRenderFns } from "./HomeRoom.vue?vue&type=template&id=b3530a62"
import script from "./HomeRoom.vue?vue&type=script&lang=ts"
export * from "./HomeRoom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports